import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import IdleTimer from 'react-idle-timer'
import { handleLogout } from '../../../data/redux/coreActions'
import authService from '../../../data/oidc/AuthService';
import { KTSVG } from '../../../_metronic/helpers';
import { IState } from '../../../data/types';


const IdleTimerWrapper = () => { 
    const dispatch = useDispatch()
    const userProfile = useSelector((state: IState) => state.core.user);
    const openModal: any = useRef(null);

    
    const InitialtimeToLogout = 20;//time in seconds
    const [timeRemaining, setTimeRemaining] = useState(InitialtimeToLogout)

    const idleTime = 1000 * 60 * 10;
    const idleTimerRef = useRef(null);
    const sessionTimeoutRef: any = useRef(null);
    const setTimeRef: any = useRef();
    const setToogleRef: any = useRef();

    function handleContinue() {
        clearTimeout(setToogleRef.current)
        document.title = 'Streamline - Process loans and credit faster'
        clearTimeout(sessionTimeoutRef.current)
        // reset cout down time
        setTimeRemaining(InitialtimeToLogout)
        clearInterval(setTimeRef.current);
    }

    async function doLogout() {
        dispatch(handleLogout());
        await authService.logout();
        clearInterval(setTimeRef.current)
    }

    const countDown = () => {
        let timeToCountDown = 20
        //Toggle title
        setToogleRef.current = setInterval(() => {
          if (document.title === 'Streamline') {
            document.title = 'You are about to be logged out'
          } else {
            document.title = 'Streamline'
          }
        }, 2000)
    
        setTimeRef.current = setInterval(function () {
          timeToCountDown -= 1;
          setTimeRemaining(timeToCountDown)
          if (timeToCountDown === 0) {
            // reset cout down time

            setTimeRemaining(InitialtimeToLogout)
            doLogout()
          }
        }, 1000);
    }
   
    const onIdle = () => {
        if(userProfile) {
          openModal.current.click()
          countDown()
        }
    }

    return (
        <>
            <IdleTimer
                ref={idleTimerRef as any}
                timeout={idleTime}
                onIdle={onIdle}>
            </IdleTimer>
            <a
              ref={openModal}
              href='#'
              className='btn btn-danger me-1'
              data-bs-toggle='modal'
              data-bs-target='#idle_logout_modal'
              id='idle_logout_modal_button'
            >
              ..
            </a>
            <div className='modal fade' id='idle_logout_modal' aria-hidden='true'>
            <div className='modal-dialog modal-dialog-centered'>
                <div className='modal-content'>
                    <div className='modal-body py-lg-5 px-lg-10 mb-10'>
                      <div className='d-flex flex-column flex-lg-row'>
                        <div className='flex-column flex-lg-row-auto w-lg-50px w-xl-50px mb-10 mt-10'>
                          <span>
                            <KTSVG path='/assets/media/icons/duotune/general/gen048.svg' className='svg-icon-dark svg-icon-large' />
                          </span>
                        </div>
                        <div className='flex-lg-row-fluid px-10'>
                          <h2 className='mt-10 mb-5'>You are about to be logged out!</h2>
                          <p>For security reasons, your connection timesout after you've been inactive for a while.</p>
                        </div>

                      </div>
                      <div className='px-10 text-end'>
                        <button type="button" className="btn btn-labo-primary mt-5" data-bs-dismiss="modal" onClick={handleContinue}>
                          Stay logged in
                          <KTSVG
                              path='/assets/media/icons/duotune/arrows/arr064.svg'
                              className='svg-icon-3 ms-2 me-0'
                          />
                        </button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
        </>
    )

}

export default IdleTimerWrapper